import { GetLink, GetLinkRes } from "../types/getLink";

export function createPath(d: GetLink): GetLinkRes {
  let res = "";
  d.args.map((v) => {
    return (res += `${v.key}=${v.value}&`);
  });
  return `${d.route}?${res}`;
}
